import React, {useState} from "react";
import {Button, Form, Image, Modal} from "react-bootstrap";
import logo from "../../../assets/img/dmarc-flow-logo.webp";
import hostname from "../../../hostname";
import appname from "../../../appname";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {routes} from "../../../routes";

export const RegisterModal = ({
                                  show,
                                  onClose,
                                  option,
                                  title = "Start your subscription",
                                  subtitle = "Secure checkout in the next step",
                                  submitLabel = "Continue to Payment",
                                  onPaymentFailed = () => {
                                  }
                              }) => {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const handlePayment = async (e, option) => {
        e.preventDefault();
        setError("");

        const response = await fetch(hostname + "/index.php/checkout", {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({
                isYearly: option.isYearly,
                plan: option.plan,
                description: option.description,
                redirectUrl: appname + "/payment-success",
                email: email
            })
        });

        const data = await response.json();
        if (data.checkoutUrl) {
            window.location.href = data.checkoutUrl;
        } else {
            let message = "";
            if (data?.error === "user already exists") {
                message = t("pages.common.registerModal.errors.exists", "This email is already registered. Try logging in instead.");
            } else if (data?.error === "email invalid") {
                message = t("pages.common.registerModal.errors.invalid", "Please enter a valid email address.");
            } else {
                message = t("pages.common.registerModal.errors.generic", "Something went wrong. Please try again later.");
            }

            setError(message);
            onPaymentFailed(data);
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered size="md" backdrop="static">
            <Form onSubmit={(e) => handlePayment(e, option)}>
                <Modal.Header className="border-0">
                    <div className="w-100 text-center">
                        <Image src={logo} alt="Your Brand" height={40} className="mb-2"/>
                        <h5 className="mt-2">{t("pages.common.registerModal.title", title)}</h5>
                        <p className="text-muted mb-0 small">{t("pages.common.registerModal.subtitle", subtitle)}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="emailInput">
                        <Form.Label>{t("pages.common.registerModal.emailLabel", "Email address")}</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="you@example.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoFocus
                            isInvalid={!!error}
                        />
                        {error && (
                            <div className="small text-danger mt-1">
                                {error}
                                {error.includes("already registered") && (
                                    <div className="mt-2">
                                        <Link to="https://app.dmarcflow.com/login" className="text-decoration-underline small">
                                            {t("pages.common.registerModal.loginLink", "Go to login →")}
                                        </Link>
                                    </div>
                                )}
                            </div>
                        )}
                    </Form.Group>
                    <div className="mt-3 small text-muted">
                        {t("pages.common.registerModal.note", "After entering your email, you'll be redirected to our secure payment partner")}{" "}
                        <strong>Mollie</strong> {t("pages.common.registerModal.ctaNote", "to complete your subscription. No account needed yet.")}.
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="ghost" className="btn-sm text-decoration-none text-muted text-black" onClick={onClose}>
                        {t("pages.common.registerModal.cancel", "Cancel")}
                    </Button>
                    <Button className="text-white" type="submit" variant="primary">
                        {t("pages.common.registerModal.submit", submitLabel)}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};
